<template>
    <div class="account-manage-wrapper" v-loading="loading">
        <el-row class="order-group-padding">
            <el-col :span="3" class="order-slide-menu">
                <div>
                    <el-menu :default-active="CurrentProduct">
                        <el-menu-item v-for="(item,key) in product" :key="key" :index="item.product_code+''"
                                      @click="switchProduct(item)">
                                    <el-tooltip :content="item.product_name + (now_time > item.end_at ? '(已到期)' : '')" placement="right">
                                        <p class="ellipsis-text">{{item.product_name}} <b style="color:#409EFF;vertical-align: bottom;">{{ now_time > item.end_at ? '(已到期)' : ''}}</b></p>
                                    </el-tooltip>
                        </el-menu-item>
                    </el-menu>
                </div>
            </el-col>
            <!--展示各个产品表单-->
            <el-col :span="21" v-loading="dynamic_loading">
                    <keep-alive>
                        <component :is="currentView" :key="CurrentProduct" v-if="product.length>0 && !dynamic_loading"
                                   :params="getParams()"></component>
                    </keep-alive>
            </el-col>
        </el-row>
    </div>
</template>
<style>
.ellipsis-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; /* 显示省略号 */
}
</style>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import CustomerService from "~/services/customer";
    import CommonService from "~/services/common";
    import xwtConfigure from "~/views/order/xwtConfigure.vue";
    import vrConfigure from "~/views/order/vrConfigure.vue";
    import zujuanConfigure from "~/views/order/zujuan/zujuanConfigure.vue";
    import jb3Configure from "~/views/order/jiaoben/configureV3.vue";
    import zujuanCorConfigure from "~/views/order/zujuan/zujuanCorConfigure.vue";
    import digitizedcampusConfigure from "~/views/order/digitizedcampusConfigure.vue";
    import paikeNewConfigure from "~/views/order/paike/paikeNewConfigure.vue";
    import divisionConfigure from "~/views/order/division/divisionConfigure.vue";
    import officialWebsiteConfigure from "~/views/order/officialWebsiteConfigure.vue";
    import otherProductConfigure from "~/views/order/otherProductConfigure.vue";
    import smartHomeworkConfigure from "~/views/order/smartHomeworkConfigure.vue";
    import teacherFilesConfigure from "~/views/order/teacherFilesConfigure.vue";
    import flexSchedulingConfigure from "~/views/order/flexSchedulingConfigure.vue";
    import beikeConfigure from "~/views/order/beikeConfigure.vue";
    // import WorkConfigure from "~/views/order/WorkConfigure.vue";
    import microClassConfigure from "~/views/order/microClassConfigure.vue";
    export default {
        name: "CustomerProducts",
        data() {
            return {
                // Config: {},
                now_time: new Date().getTime(),
                CurrentProduct: '',
                dynamic_loading: false,
                current_product_config: '',
                loading: false,
                loading_text: "产品加载中",
                product: [],
                /**
                 * @todo 根据后台返回展示，暂时写死
                 * */
                productMap: []
            }
        },
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
            isEdit: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            // 分页组件
            Pagination,
            xwtConfigure,
            vrConfigure,
            zujuanConfigure,
            jb3Configure,
            zujuanCorConfigure,
            digitizedcampusConfigure,
            paikeNewConfigure,
            divisionConfigure,
            officialWebsiteConfigure,
            otherProductConfigure,
            smartHomeworkConfigure,
            teacherFilesConfigure,
            flexSchedulingConfigure,
            beikeConfigure,
            // WorkConfigure,
            microClassConfigure,
        },

        computed: {
            currentView: function () {
                let product = this.productMap.find(i => {
                    return i.code == this.CurrentProduct
                });
                if (!product || !product['component']) {
                    return 'otherProductConfigure';
                }
                console.log('切换产品组件：', product['component'] + 'Configure');
                return product['component'] + 'Configure';
            }
        },
        created: function () {
            this.getProducts();
        },
        mounted: function () {
            this.getCustomerInfo();
        },
        methods: {
            //默认加载
            getProducts() {
                this.loading = true;
                //加载产品配置列表
                CommonService.getProducts({
                    scenary: 'show-all',
                }).then(res => {
                    this.productMap = res.data
                    this.loading = false;
                });
            },
            getParams() {
                let params = this.product.find(i => {
                    return i.product_code == this.CurrentProduct
                });
                params['customer_product_list'] = this.product.map(item => item.product_appid);
                params['config'] = this.current_product_config;
                params['isEdit'] = this.isEdit;
                params['product_list'] = this.productMap;
                console.log('获取产品配置：', this.product, params);
                //获取所有开通产品code码
                return params
            },
            get_product_config() {
                if(!this.CurrentProduct){ return false;}
                this.dynamic_loading = true;
                CustomerService.product_config({
                    product_code: this.CurrentProduct,
                    customer_id: this.customerId
                }).then(res => {
                    this.current_product_config = res.data;
                    this.dynamic_loading = false;
                })
            },
            //客户开通产品信息
            getCustomerProducts() {
                this.loading = true;
                CustomerService.getProducts(this.customerId).then(res => {
                    if (res.data.length > 0) {
                        this.product = res.data;
                        this.CurrentProduct = (this.$route.query['code'] && this.product.filter((item)=> { return item.code == this.$route.query['code'] }).length > 0) ? this.$route.query['code'] + '' : res.data[0]['product_code'] + '';
                        this.get_product_config();
                    } else {
                        this.$confirm('该客户暂无产品，点击开单购买产品', '提示信息', {
                            distinguishCancelAndClose: true,
                            confirmButtonText: '开单',
                            cancelButtonText: '放弃'
                        }).then(() => {
                            let path = "/order/create?customer_id=" + this.customerId;
                            this.$router.push({
                                path: path,
                                query: {
                                    referer: this.$route.path
                                }
                            });
                        }).catch(action => {
                            let path = "/customers/view?id=" + this.customerId;
                            this.$router.push({
                                path: path,
                                query: {
                                    referer: this.$route.path
                                }
                            });
                        });
                    }
                    this.loading = false;
                })
            },
            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchPageChange(pageParams) {
                let params = this.searchVal;
                params['customer_id'] = this.customerId;
                params['page'] = pageParams["page"];
                params['perPage'] = pageParams["perPage"];
            },
            getCustomerInfo() {
                CustomerService.getInfo(this.$route.query['id']).then(res => {
                    if (res.code == 0) {
                        global.periods = [];
                        global.periods = res.data['periods'];
                    }
                }).then(this.getCustomerProducts).then(this.get_product_config);
            },
            switchProduct(product) {
                this.CurrentProduct = product.product_code + '';
                
                this.get_product_config();
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/customer/products.vue